function educationMapping(data = {}, index) {
  const gradYear = new Date(data.EDU_END_DATE).getFullYear()

  return {
    key: index,
    degree: data.GRAD_NAME_THAI ? data.GRAD_NAME_THAI : null,
    university: data.UNIV_NAME_THAI ? data.UNIV_NAME_THAI : null,
    major: data.MAJOR_NAME_THAI ? data.MAJOR_NAME_THAI : null,
    country: data.COUNTRY_NAME_ENG ? data.COUNTRY_NAME_ENG : null,
    gradYear: gradYear ? gradYear : null
  }
}

export default educationMapping
